//imports

import {Card, CardContent, Divider, Skeleton, Typography} from "@mui/material";

const CarouselSkeleton = () => {
  return (
    <Card sx={{
      mx: 2,
      mb: 3,
      position: 'relative',
    }}>
      <Skeleton variant='rectangular' width={'100%'} height={178} />
      <Divider/>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}><Skeleton /></Typography>
        <Typography variant="h6" ><Skeleton /></Typography>
        <Typography variant="h6" ><Skeleton /></Typography>
      </CardContent>
    </Card>
  )
}

export default CarouselSkeleton
